import { useEffect } from 'react'

const useScript = (url: string, onload?: () => void, props?: object) => {
  useEffect(() => {
    if (!url) return

    const script = document.createElement('script')

    script.src = url
    script.async = true

    if (onload) {
      script.onload = onload
    }

    if (props) {
      for (let i = 0; i < Object.keys(props).length; i += 1) {
        const key = Object.keys(props)[i]
        script[key] = props[key]
      }
    }

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [url])
}

export default useScript
